import { useLayoutEffect } from 'react';
let dismissed = false;
/** Fades out the fixed `#rl-boot-skeleton` overlay from `public/index.html`. */ export const dismissBootSkeleton = ()=>{
    if (dismissed) {
        return;
    }
    dismissed = true;
    const remove = window.__removeBootSkeleton;
    remove === null || remove === void 0 ? void 0 : remove();
};
export const useDismissBootSkeleton = (enabled = true)=>{
    useLayoutEffect(()=>{
        if (enabled) {
            dismissBootSkeleton();
        }
    }, [
        enabled
    ]);
};
